import React, { useState, useEffect } from 'react';
import Helpers from 'utils/helpers';
import './stepperHorizontal.css';
import './stepperVertical.css';

function Stepper(props) {
  const [currentStep, setCurrentStep] = useState(1);

  useEffect(() => {
    setCurrentStep(props.step);
  }, [props.step])

  const handleStepChange = (newStep) => {
    if (props.onStepChange) {
      props.onStepChange(newStep);
    }
    setCurrentStep(newStep);
  };

  const renderTitle = () => {
    return React.Children.map(props.children, (child, i) => {
      if (i + 1 === currentStep) {
        return child.props.title;
      }
    });
  };

  const renderSteps = () => {
    const children = props.children;
    const count = React.Children.count(children);
    return React.Children.map(children, (child, i) => {
      return React.cloneElement(child, {
        step: i + 1,
        of: count,
        currentStep: currentStep,
        onStepClick: handleStepChange,
      });
    });
  };

  const getClass = () => {
    let classNames = [];
    classNames.push(props.className);
    if (props.vertical) {
      classNames.push('stepper-v');
    }
    else {
      classNames.push('stepper-h');
    }
    return Helpers.String.join(classNames);
  };

  return (
    <div className={getClass()}>
      <div className='stepper-content'>
        {renderSteps()}
      </div>
      <div className='stepper-helper'>
        {renderTitle()}
      </div>
    </div>
  );
}

function StepperStep(props) {
  const handleClick = () => {
    if (props.lockForwardStep && props.step >= props.currentStep) {
      //prevent from clicking future steps
      return;
    }
    if (props.step === props.currentStep) {
      //prevent from clicking current step
      return;
    }
    if (props.onStepClick) {
      props.onStepClick(props.step);
    }
  };

  const getClass = () => {
    let classNames = [];
    classNames.push('stepper-step');
    if (props.currentStep > props.step) {
      classNames.push('stepper-step-done');
    }
    else if (props.currentStep === props.step) {
      classNames.push('stepper-step-current');
    }
    if (props.step === 1) {
      classNames.push('stepper-step-first');
    }
    if (props.step === props.of) {
      classNames.push('stepper-step-last');
    }
    return Helpers.String.join(classNames);
  };

  const getLinkClass = () => {
    let classNames = [];
    classNames.push('stepper-step-link');
    if (props.currentStep > props.step) {
      if (props.invalid) {
        //previous step, invalid
        classNames.push('bg-light');
        classNames.push('border-danger');
        classNames.push('text-danger');
      }
      else {
        //previous step, valid
        classNames.push('bg-light');
        classNames.push('border-success');
        classNames.push('text-success');
      }
    }
    else if (props.currentStep === props.step) {
      //current step
      classNames.push('bg-dark');
      classNames.push('border-dark');
      classNames.push('text-light');
      classNames.push('cursor-default');
    }
    else {
      //future step
      classNames.push('bg-light');
      classNames.push('border-dark');
      classNames.push('text-dark');
      if (props.lockForwardStep) {
        classNames.push('cursor-default');
      }
    }
    return Helpers.String.join(classNames);
  };

  return (
    <div className={getClass()}>
      <div className={getLinkClass()} onClick={handleClick}>
        <span className='stepper-step-title'>{props.step}</span>
        <span className='stepper-step-desc text-dark'>{props.title}</span>
      </div>
    </div>
  );
}

Stepper.Step = StepperStep;

export default Stepper;
